import { AxiosResponse } from "axios";
import { invalidateWelcomeDashboardAccess } from "./welcomeDashboardAccessPolicy";
import { useEffect } from "react";
import { QueryClient, useMutation, useQuery, useQueryClient } from "react-query";
import { IPermission } from "../../compiler/global.interface";
import { IUserAccessManageProps } from "../../components/pages/Setting/Access/User/UserAccessManage";
import { IUserInformationFormValues } from "../../components/pages/Setting/Access/User/UserInformation";
import { IUserMemberManageFormValues } from "../../components/pages/Setting/Access/User/UserMemberManage";
import { IGroupFormValues } from "../../components/pages/Setting/Access/UserGroup/UserGroupInformation";
import { IMemberInGroupFormValues } from "../../components/pages/Setting/Access/UserGroup/UserGroupManage";
import { APIAddMemberToGroupByUUID, APICreateGroup, APIGetAllGroups, APIGetGroupMembersByUUID, APIGetGroupPermissionByUUID, APIGetMemberGroupByUUID, APIUpdateGroupByUUID, APIUpdateGroupPermissionByUUID, APIUpdateGroupUserByUUID } from "../../service/api/APIGroupCRUD";
import { APICreateUser, APIGetAllUsers, APIUpdateUserByUUID, APIUpdateUserGroupByUUID, APIUpdateUserPasswordByUUID, APIUpdateUserPermissionByUUID } from "../../service/api/APIUserCRUD";

export enum EQueryUserCRUD {
    GetAllGroups = 'GetAllGroups',
    GetGroupMembersByUUID = 'GetGroupMembersByUUID',
    GetMemberGroupByUUID = 'GetMemberGroupByUUID',
    GetGroupPermissionByUUID = 'GetGroupPermissionByUUID',
    CreateGroup = 'CreateGroup',
    AddMemberInGroup = 'AddMemberInGroup',
    EditGroupByUUID= 'EditGroupByUUID',
    EditGroupUserByUUID = 'EditGroupUserByUUID',
    EditGroupPermissionByUUID = 'EditGroupPermissionByUUID',
    EditUserPermissionByUUID = 'EditUserPermissionByUUID',
    EditUserPasswordByUUID = 'EditUserPasswordByUUID'
}

export const useGetAllGroups = () => {
    return useQuery(EQueryUserCRUD.GetAllGroups,() => APIGetAllGroups())
}

export const useGetGroupMembersByUUID = (uuid) => {
    return useQuery([EQueryUserCRUD.GetGroupMembersByUUID, uuid], () => APIGetGroupMembersByUUID(uuid), {
        enabled: !!uuid
    })
}

export const useGetMemberGroupByUUID = (uuid) => {
    return useQuery([EQueryUserCRUD.GetMemberGroupByUUID, uuid], () => APIGetMemberGroupByUUID(uuid), {
        enabled: !!uuid
    })
}

export const useGetGroupPermissionByUUID = (uuid) => {
    return useQuery([EQueryUserCRUD.GetGroupPermissionByUUID, uuid],() => APIGetGroupPermissionByUUID(uuid),{
        enabled:!!uuid
    })
}

export const useEditGroupPermissionByUUID = (uuid: string) => {
    const queryClient = useQueryClient()

    return useMutation(EQueryUserCRUD.EditGroupPermissionByUUID, (payload: { permissionData: IPermission[] }) => APIUpdateGroupPermissionByUUID(uuid, payload), {
        onSuccess: () => {
            queryClient.invalidateQueries([EQueryUserCRUD.GetGroupPermissionByUUID, uuid])
            void invalidateWelcomeDashboardAccess(queryClient)
        }
    })
}

export const useCreateGroup = () => {
    const queryClient = useQueryClient()

    return useMutation(EQueryUserCRUD.CreateGroup,(payload:IGroupFormValues) => APICreateGroup(payload),{
        onSuccess:()=>{
            queryClient.invalidateQueries(EQueryUserCRUD.GetAllGroups)
            void invalidateWelcomeDashboardAccess(queryClient)
        }
    })
}

export const useAddMemberToGroupByUUID = (uuid: string | null) => {
    const queryClient = useQueryClient()

    return useMutation(EQueryUserCRUD.AddMemberInGroup, (payload: { members: IMemberInGroupFormValues[] }) => APIAddMemberToGroupByUUID(uuid, payload), { onSuccess: () => invalidateWelcomeDashboardAccess(queryClient) })
}


export const useEditGroupByUUID = (uuid:string | null) => {
    const queryClient = useQueryClient()
    
    return useMutation(EQueryUserCRUD.EditGroupByUUID,(payload:IGroupFormValues)=>APIUpdateGroupByUUID(uuid || '',payload),{
        onSuccess:()=>{
            queryClient.invalidateQueries(EQueryUserCRUD.GetAllGroups)
            void invalidateWelcomeDashboardAccess(queryClient)
        }
    })
}

export const useEditGroupUserByUUID = (uuid:string | null) => {
    const queryClient = useQueryClient()
    
    return useMutation(EQueryUserCRUD.EditGroupUserByUUID,(payload:IPermission[])=>APIUpdateGroupUserByUUID(uuid,payload), { onSuccess: () => invalidateWelcomeDashboardAccess(queryClient) })
}

// export const useDeleteUserCRUD = () => {
//     const queryClient = useQueryClient()
    
//     return useMutation<AxiosResponse,Error,IUseGetUserCRUDProps>(EQuery[Doamin].GetUserCRUD, [API]})
// }
